import React, { useState } from "react";
import { fetchGet } from "../utils";

export default function Phone() {
  const [phoneNumber, setPhoneNumber] = useState(null);
  const getTwilioPhone = async () => {
    const { body } = await fetchGet({
      url: "/api/phone",
      onError: console.error,
    });
    setPhoneNumber(body.phone);
  };

  return (
    <>
      <h1>Get HUB phone number</h1>
      <p>
        <strong>IMPORTANT: DO NOT SHARE THIS NUMBER</strong>
      </p>
      <p>This number can be texted with messages, photos, audio, etc.</p>
      <button onClick={getTwilioPhone}>Get phone number</button>
      <br />
      <br />
      {phoneNumber && (
        <p id="phone-res">
          <strong>Phone: </strong>
          <pre>{phoneNumber}</pre>
        </p>
      )}
    </>
  );
}
